import React from "react"
import {
    Shipping,
    Payment,
    // Support,
    Quality,
    ArrowFooter,
    PhoneFooter,
    EmailFooter
} from "../../assets/icons/icons";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import { useState, useEffect } from "react";
import axios from "axios";
export default function Footer() {
    const { t, i18n } = useTranslation();
    UseScrollAnimation();

    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/categories");
                setData(response.data.category);
            } catch (error) {
                console.error("Error When Fetch Data : ", error);
            }
        };
        fetchData();
    }, []);


    return (
        <>
            <section className="bg-[#1485a6]">
                <div className="container f-wrap gg-2  py-[40px] flex flex-col gap-[20px]">
                    <div className="gg-15-px flex items-center justify-around flex-wrap gap-[10px]">
                        <div className="w-100 js-scroll fade-top flex items-center gap-[10px] dir">
                            <Shipping />
                            <span className="tx-cent-res flex items-center gap-[4px] font-bold text-white">التوصيل صار دينار واحد بس</span>
                        </div>
                        <div className="w-100 js-scroll fade-btm tx-cent-res flex items-center gap-[10px] dir">
                            <Payment />
                            <span className="font-bold text-white">امكانية الدفع عن طريق كليك</span>
                        </div>
                        <div className="w-100 js-scroll fade-btm tx-cent-res flex items-center gap-[10px] dir">
                            <Quality />
                            <span className="font-bold text-white">اسألنا عن كفالة AJ</span>
                        </div>
                    </div>

                    <div className="flex flex-col items-center justify-center text-center gap-[4px]">
                        <div className="text-[20px] text-white capitalize">{t("Follow us here")}</div>
                        <div className="flex items-center gap-[7px]">
                            <Link to={"https://www.facebook.com/people/AJ-Mart/61573171957943/"} className="w-[2rem] h-[2rem] bg-white flex items-center justify-center shadow-md rounded-full">
                                <img className="w-[18px] h-[18px]" src={require("../../assets/icons/facebook.svg").default} alt="" />
                            </Link>
                            <Link to={"https://www.instagram.com/aj_mart.jo/?hl=en"} className="w-[2rem] h-[2rem] bg-white flex items-center justify-center shadow-md rounded-full">
                                <img className="w-[18px] h-[18px]" src={require("../../assets/icons/instagram.svg").default} alt="" />
                            </Link>
                            <Link to={"https://wa.link/ppk1jv"} className="w-[2rem] h-[2rem] bg-white flex items-center justify-center shadow-md rounded-full">
                                <img className="w-[18px] h-[18px]" src={require("../../assets/icons/Whatsapp.svg").default} alt="" />
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            <footer>
                <div className="container">
                    <div className="f-col gap-10 py-[20px] flex justify-between">
                        <div className="w-100 w-[35%] flex flex-col gap-[20px]">
                            <div>
                                <img className="w-[125px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                            </div>
                            {/* <div className="flex items-center gap-[7px]">
                                <Link to={"https://www.facebook.com/people/AJ-Mart/61573171957943/"} className="w-[3rem] h-[3rem] flex items-center justify-center shadow-md rounded-full">
                                    <img className="w-[25px] h-[25px]" src={require("../../assets/icons/facebook.svg").default} alt="" />
                                </Link>
                                <Link to={"https://www.instagram.com/aj_mart.jo/?hl=en"} className="w-[3rem] h-[3rem] flex items-center justify-center shadow-md rounded-full">
                                    <img className="w-[25px] h-[25px]" src={require("../../assets/icons/instagram.svg").default} alt="" />
                                </Link>
                                <Link to={"https://wa.link/ppk1jv"} className="w-[3rem] h-[3rem] flex items-center justify-center shadow-md rounded-full">
                                    <img className="w-[25px] h-[25px]" src={require("../../assets/icons/Whatsapp.svg").default} alt="" />
                                </Link>
                            </div> */}
                        </div>
                        <div className="w-100 f-col w-[55%] flex gap-[40px] justify-end">
                            <div className="flex flex-col gap-[15px]">
                                <div className="capitalize font-bold text-[20px]">{t("Quick Links")}</div>
                                <ul className="flex flex-col gap-[7px]">
                                    <li>
                                        <Link className="flex items-center gap-[5px] font-medium hover:text-[#1485a6] transition duration-500 ease-in-out" to={"/about"}>
                                            <div className="transform-ar">
                                                <ArrowFooter />
                                            </div>
                                            {t("About us")}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="flex items-center gap-[5px] font-medium hover:text-[#1485a6] transition duration-500 ease-in-out" to={"/contact"}>
                                            <div className="transform-ar">
                                                <ArrowFooter />
                                            </div>
                                            {t("Contact us")}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="flex items-center gap-[5px] font-medium hover:text-[#1485a6] transition duration-500 ease-in-out" to={"/cart"}>
                                            <div className="transform-ar">
                                                <ArrowFooter />
                                            </div>
                                            {t("Cart")}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="flex items-center gap-[5px] font-medium hover:text-[#1485a6] transition duration-500 ease-in-out" to={"/privacy"}>
                                            <div className="transform-ar">
                                                <ArrowFooter />
                                            </div>
                                            {t("Privacy Policy")}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="flex items-center gap-[5px] font-medium hover:text-[#1485a6] transition duration-500 ease-in-out" to={"/terms"}>
                                            <div className="transform-ar">
                                                <ArrowFooter />
                                            </div>
                                            {t("Terms of Service")}
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="flex flex-col gap-[15px]">
                                <div className="capitalize font-bold text-[20px]">{t("categorys")}</div>
                                <ul className="flex flex-col gap-[7px]">
                                    {data.slice(0, 6).map(el => (
                                        <li key={el.category_id}>
                                            <a
                                                className="flex items-center gap-[5px] font-medium hover:text-[#1485a6] transition duration-500 ease-in-out"
                                                href={`/mainCategories/${el.category_name_E}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.location.href = `/mainCategories/${el.category_name_E}`;
                                                }}
                                            >
                                                <div className="transform-ar">
                                                    <ArrowFooter />
                                                </div>
                                                {i18n.language === 'ar' ? el.category_name_A : el.category_name_E}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="flex flex-col gap-[15px]">
                                <div className="capitalize font-bold text-[20px]">{t("Contact us")}</div>
                                <ul className="flex flex-col gap-[7px]">
                                    <li>
                                        <Link className="flex items-center gap-[5px] font-medium hover:text-[#1485a6] transition duration-500 ease-in-out" to={"tel:0790773377"}>
                                            <div><PhoneFooter /></div>
                                            <span className="direction-ar">+962 79 077 3377</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="flex items-center gap-[5px] font-medium hover:text-[#1485a6] transition duration-500 ease-in-out" to={"mailto:info@aj-mart.com"}>
                                            <div><EmailFooter /></div>
                                            <span>info@aj-mart.com</span>
                                        </Link>
                                    </li>
                                
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="h-[2px] bg-[#666666]"></div>
                    <div className="cus-footer flex items-center justify-between py-[15px]">
                            <div className="font-bold">
                            {t("Copyright ©️ 2025 AJ Stor. All Rights Reserved.")}{" "}
                            <div>
                            <a 
                                href="https://petra-ms.com/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-black hover:underline"
                            >
                                {t("Developed By Petra MS")}
                            </a>
                            </div>
                            </div>            
                          <div className="flex items-center gap-[10px]">
                            <img src={require("../../assets/images/footer-pay-2.svg").default} alt="" />
                            <img src={require("../../assets/images/footer-pay-1.svg").default} alt="" />
                        </div>
                    </div>
                </div>
         
            </footer>
        </>
    )
}
